// Copyright 2023 Sorama B.V.

import { Unit, UnitType } from "units/Unit";
import { CompositeUnit } from "./CompositeUnit";
import { Currency } from "./Currency";

export class Mass extends UnitType {
    public static override typeName = "Mass";

    public static milliGram: Unit = new Unit("mg", 1e-6, Mass);
    public static gram: Unit = new Unit("g", 1e-3, Mass);
    public static kiloGram: Unit = new Unit("kg", 1, Mass);
    public static ton: Unit = new Unit("t", 1e3, Mass);

    public static pound: Unit = new Unit("lb", 0.45359237, Mass);
    public static ounce: Unit = new Unit("oz", 0.028349523125, Mass);
}

export class MassCost extends UnitType {
    public static typeName = "Mass price";

    public static euroPerGram: CompositeUnit = new CompositeUnit(Currency.EUR, Mass.gram, MassCost, {
        aliases: ["EUR/g", "EUR/gram"],
    });
}
